import React, { useState, useEffect, useRef } from 'react';
import './AutoSearch.scss';

const AutoSearch = ({
  placeholder = 'Search...',
  onSelect = () => {},
  onSearch = async (query) => [], // async function to call API
  minLength = 3,
  debounceTime = 300,
}) => {
  const [input, setInput] = useState('');
  const [results, setResults] = useState([]);
  const [showList, setShowList] = useState(false);
  const [loading, setLoading] = useState(false);
  const debounceTimeout = useRef(null);
  const skipSearch = useRef(false);
  const wrapperRef = useRef(null); // ref for detecting outside click
  // Handle API search with debounce
  useEffect(() => {
    if (skipSearch.current) {
      skipSearch.current = false;
      return;
    }

    if (input.length >= minLength) {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

      debounceTimeout.current = setTimeout(async () => {
        setLoading(true);
        try {
          const res = await onSearch(input);
          setResults(res);
          setShowList(true);
        } catch (err) {
          console.error('Search error:', err);
        }
        setLoading(false);
      }, debounceTime);
    } else {
      setResults([]);
      setShowList(false);
    }

    return () => clearTimeout(debounceTimeout.current);
  }, [input, minLength, debounceTime, onSearch]);

  // Detect clicks outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowList(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (item) => {
    onSelect(item);
    skipSearch.current = true;
    setInput(item.label);
    setShowList(false);
  };

  return (
    <div className="auto-search position-relative" ref={wrapperRef}>
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        autoComplete="off"
      />
      {showList && (
        <div className="search-dropdown shadow-sm">
          {loading ? (
            <div className="search-item">Loading...</div>
          ) : results.length > 0 ? (
            results.map((item) => (
              <div
                key={item.id}
                className="search-item"
                onClick={() => handleSelect(item)}
              >
                <strong>{item.label}</strong> {item.subLabel}
              </div>
            ))
          ) : (
            <div className="no-result">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default AutoSearch;
